import React, {useState} from "react";
import {useForm} from "react-hook-form";
import ContinueShoppingFields from "./ContinueShoppingFields";
import axios from "axios";

export default function () {
  const {register, handleSubmit, reset, control, watch, setValue, getValues} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});

  const searchProduct = (val) => {
    let selectedProducts = getValues('products');
    return axios.get('sliders/search-products', {
      params: {
        keyword: val,
        product_ids: selectedProducts,
        category_id: getValues('category_id'),
        shop_id: getValues('shop_id')
      }
    }).then(res => {
      setData({...data, products: res.data?.products});
      return res.data?.products;
    });
  }

  const continueShoppingFields = <ContinueShoppingFields {...{register, errors, control, watch, setValue, data, setData, getValues, searchProduct}} />;

  return {
    setErrors,
    continueShoppingFields,
    handleSubmit,
    data,
    setData,
    reset,
  }
}